 <template>
	<v-container class="noMargin">		
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>SPEC STATUS</h2>					
				</div>
				<v-btn @click.prevent="fncAddStatus" class="elevation-5" color="info"><i class="material-icons">add</i>Create Status</v-btn>
				<v-btn @click.prevent="fncReloadRfcStatus" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddStatus() {
				var modalDetails = { title: 'Add Spec Status', component: 'modal-rfc-status-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			},
			fncImportStatus() {
				var modalDetails = { title: 'Import Status', component: 'modal-status-import', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncReloadRfcStatus() {
              this.$store.dispatch({
                type: 'fncPopulateSpecStatusList',
                reload: true
              });
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>